import './GaugeLabel.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var elementLabelWrapper = '_18ourc20-3-12-1';
export var foreignObjectContainer = _7a468({defaultClassName:'_18ourc21-3-12-1',variantClassNames:{dominantBaseline:{auto:'_18ourc22-3-12-1',hanging:'_18ourc23-3-12-1'}},defaultVariants:{dominantBaseline:'hanging'},compoundVariants:[]});
export var textContainer = '_18ourc24-3-12-1';